import { Button, Flex } from "@chakra-ui/react";
import { VFC } from "react";

import { User } from "api/get-user";
import {
  MobileSearchButton,
  SearchBox,
} from "components/commandbar/search/search-box";
import { CTALinks } from "components/cta-links";
import { ChangelogLink } from "components/cta-links/cta-links";
import { track } from "lib/analytics";
import { Link } from "ui";
import { MenuIcon, CloseIcon } from "ui/icons";
import { Logo } from "ui/logo";

type Props = {
  loadingUser: boolean;
  user?: User;
  navOpen?: boolean;
  toggleNav?: () => void;
};

export const Topbar: VFC<Readonly<Props>> = ({
  user,
  toggleNav,
  navOpen,
  loadingUser,
}) => {
  return (
    <Flex
      pos="sticky"
      top={0}
      left={0}
      as="header"
      align="center"
      justify="center"
      bg="rgba(255, 255, 255, 0.92)"
      sx={{ backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)" }}
      height="var(--theme-sizes-header)"
      borderBottom="1px"
      borderColor="base.divider"
      zIndex={3}
    >
      <Flex
        px={{ base: 4, md: 6 }}
        flex={1}
        justify="space-between"
        align="center"
      >
        <Flex align="center" flex={1} mr={4}>
          <Link
            aria-label="Hightouch Docs Home"
            href="/"
            mr={{ base: 3, md: 4 }}
            flexShrink={0}
            display="block"
          >
            <Logo width="auto" height="20px" />
          </Link>
          <SearchBox />
        </Flex>

        <Flex
          display={["flex", "flex", "none"]}
          ml="auto"
          align="center"
          gap={1}
        >
          <MobileSearchButton />
          <Button
            variant="subtle"
            aria-label={
              navOpen ? "Close navigation menu" : "Open navigation menu"
            }
            aria-expanded={navOpen}
            aria-controls="mobile-nav"
            onClick={toggleNav}
          >
            {navOpen ? <CloseIcon boxSize={6} /> : <MenuIcon boxSize={6} />}
          </Button>
        </Flex>
        <Flex
          display={{ base: "none", md: "flex" }}
          alignItems="end"
          mt={"auto"}
          gap={3}
        >
          {user ? (
            <Flex align="center" gap={3}>
              <ChangelogLink />
              <Button
                onClick={() => {
                  window.location.href = "https://app.hightouch.com";
                  track("Dashboard Button Clicked");
                }}
              >
                Go to app
              </Button>
            </Flex>
          ) : (
            <CTALinks primary="signup" includeChangelog hideSecondary />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
